import { useEffect } from "react";
import { Outlet } from "react-router-dom";

import { AdminChatsProvider, useAdminChats } from "../model/AdminChatsContext";

import styles from "./AdminChatsLayout.module.scss";

const AdminChatsLayoutContent = () => {
  const { ensureChats } = useAdminChats();

  useEffect(() => {
    ensureChats();
  }, [ensureChats]);

  return (
    <div className={styles.page}>
      <div className={styles.inner}>
        <div className={styles.content}>
          <Outlet />
        </div>
      </div>
    </div>
  );
};

export const AdminChatsLayout = () => {
  return (
    <AdminChatsProvider>
      <AdminChatsLayoutContent />
    </AdminChatsProvider>
  );
};


















